import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (localStorage.getItem('epas_user') === '' || localStorage.getItem('epas_user') === null
        || localStorage.getItem('epas_user') === undefined) {
      this.router.navigate(['']);
      return false;
    }
    return true;
  }
}
